module.exports = __webpack_public_path__ + "background-login.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images2/background-login.png
 ** module id = 270
 ** module chunks = 0
 **/